import template from 'lodash.template';

import { interpolateMissingKeyHTML } from './interpolate-missing-html';

export const interpolateMustachifiedHTML = (html: string, context: Record<string, unknown>) => {
  let compiled;
  try {
    compiled = template(html, {
      interpolate: /\{\{([\s\S]+?)\}\}/g,
    });
  } catch (error) {
    return html;
  }

  const contextStrippedOfPaths = Object.keys(context).reduce<Record<string, unknown>>(
    (memo, keyPath) => {
      const inputName = keyPath.substring(keyPath.indexOf('.') + 1);

      if (memo[inputName]) {
        // eslint-disable-next-line
        console.trace(`${inputName} overwritten. It is used across multiple Flow steps`);
      }
      if (inputName.indexOf('.') === -1) {
        return { ...memo, [inputName]: context[keyPath] };
      }
      const value = inputName.split('.');
      const m = memo[value[0]];
      return {
        ...memo,
        [value[0]]: {
          ...(typeof m === 'object' ? m : {}),
          [value[1]]: context[keyPath],
        },
      };
    },
    {},
  );

  let res = '';
  let keepTrying = true;
  do {
    try {
      if (!compiled) throw Error('Issue compiling');
      res = compiled(contextStrippedOfPaths);
      keepTrying = false;
    } catch (error) {
      let missingKeyName = null;
      const errorMessage = error.message as string;
      if (
        errorMessage.includes('Cannot read properties of undefined') ||
        errorMessage.includes('Issue compiling')
      ) {
        // mustache failed interpolation, but we still want to show the html
        const missingKey = error.message.split(' ')[0];
        return interpolateMissingKeyHTML(html, missingKey);
      }
      if (error.message.indexOf("Can't find variable: ") > -1) {
        missingKeyName = error.message.substring(
          error.message.indexOf("Can't find variable: ") + 21,
        );
      }
      if (errorMessage.indexOf(' is not defined') > -1) {
        missingKeyName = error.message.substring(error.message.indexOf(' is not defined'), 0);
      }
      missingKeyName ? (contextStrippedOfPaths[missingKeyName] = '') : (keepTrying = false);
    }
  } while (keepTrying);

  return res;
};

export default {
  interpolateMustachifiedHTML,
};
